 function updateCounter(inputId, counterId, maxLength) {
    const input = document.getElementById(inputId);
    const counter = document.getElementById(counterId);

    function update() {
      const length = input.value.length;
      counter.textContent = `${length}/${maxLength}`;

      if (length >= maxLength) {
        counter.classList.add('over-limit');
      } else {
        counter.classList.remove('over-limit');
      }
    }

    input.addEventListener('input', update);
    update(); // Initial update
  }

  // Initialize counters
  updateCounter('plaque-message', 'plaque-counter', 30);
  updateCounter('box-message', 'box-counter', 100);




// Hide Instagram Icon on home annd product page
$(document).ready(function() {
    function hideInstaIcon() {
            $('.reelUp_verified').css('display', 'none'); 
    }
      hideInstaIcon();
});




$(document).ready(function() {
  // Cache the original position of the buy button
  var $buyButton = $('.cstm-buy-button-resp');
  var $productDescription = $('.product__description');

  // Store the original parent of the buy button
  var originalParent = $buyButton.parent();

  function moveBuyButton() {
    if ($(window).width() < 768) { // For mobile view
      if (!$buyButton.hasClass('moved')) {
        // Move buy button before product description and add 'moved' class
        $buyButton.insertBefore($productDescription).addClass('moved');
      }
    } else { // For desktop/tablet view
      if ($buyButton.hasClass('moved')) {
        // Move back to its original parent if it has the 'moved' class
        $buyButton.appendTo(originalParent).removeClass('moved');
      }
    }
  }

  // Call the function on page load
  moveBuyButton();

  // Recheck on window resize
  $(window).resize(function() {
    moveBuyButton();
  });
});


